import React, { useRef, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import Confetti from "react-confetti";
import { Link } from "react-router-dom";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import Popover from "react-bootstrap/Popover";
import {
  FetchArticleById,
  iniitatePayments,
  updatePayment,
  downloadOrsendReceipt,
  FetchAllOfferForPayment,
  FetchMudraByUserId,
  FetchOfferById,
} from "../../autherFlow/submitArticle/queries";
import { acceptRejectArticle } from "../../../store/apiCalls/dashboard";
import {
  createNewArticleVersion,
  getAPCValues,
  publishFromAdminSideApi,
} from "../../../store/apiCalls/articles";
import Header from "../../../layout/header";
import successful from "../../../assets/img/icons/successful.svg";
import alertSvg from "../../../assets/img/icons/alert_info.svg";
import doneSvg from "../../../assets/img/icons/done02.svg";
import copyIcon from "../../../assets/img/icons/copy.svg";
import coupanIcon from "../../../assets/img/icons/save.svg";
import active_info from "../../../svg/active-info.svg";
import Checkbox from "../../../components/common/Checkbox";
import { SERVER_URL } from "../../../config";
import { downLoadFile } from "../../../utils";

// import ToolTip from "../../common/ToolTip";

const societyConferenceTotal = 2999;
const societyConferenceBaseAPC = Number((societyConferenceTotal / 1.18).toFixed(2));

function articleRegistrationPayment() {
  const navigate = useNavigate();
  const router = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state?.LoginReducer);

  const [finalPaymentStatus, setFinalPaymentStatus] = useState(false);
  const [amountToPay, setamountToPay] = useState({
    currencyType: "INR",
    initialAmt: 1000,
    finalAmt: 6000,
    listpriceFinal: 0,
    listPriceInitial: 0,
    initialStrike: false,
    finalStrike: false,
  });
  console.log(amountToPay, "amountToPay");
  const [activeTabs, setactiveTabs] = useState({
    paymentDetail: true,
    success: false,
    aggryToc: false,
    getReceipt: false,
  });
  const [paymentFailedPopup, setpaymentFailedPopup] = useState({
    status: false,
    txnId: "",
    card_type: "",
  });
  const [articleDetail, setarticleDetail] = useState();
  const [isPageLoaded, setisPageLoaded] = useState(false);
  const [paymentSuccess, setpaymentSuccess] = useState(false);
  const [availableCoupan, setavailableCoupan] = useState(false);
  const [isDownLoadPdf, setisDownLoadPdf] = useState(false);
  const [isInitialPayment, setisInitialPayment] = useState(true);
  const [articlePublishedModal, setarticlePublishedModal] = useState(false);
  const [mwpPublishedModal, setMwpPublishedModal] = useState(false);
  const [mudras, setmudras] = useState(0);
  const [offers, setoffers] = useState([]);
  const [initialPaymentDtl, setinitialPaymentDtl] = useState({
    initialAmt: amountToPay.initialAmt,
    isCouponApplied: false,
    couponCode: "",
    couponAmt: 0,
    couponId: "",
  });
  const [finalPaymentDtl, setfinalPaymentDtl] = useState({
    id: "",
    Peid: "",
    isTermAccept: false,
    finalAmt: amountToPay.finalAmt,
    isMudraApplied: false,
    mudraAmnt: 0,
    isGrantApplied: false,
    grantAmount: 0,
    sgst: 0,
    cgst: 0,
    isCouponApplied: false,
    couponCode: "",
    couponId: "",
    couponAmt: 0,
  });
  const finalPaymentDtlRef = useRef(finalPaymentDtl);

  finalPaymentDtlRef.current = finalPaymentDtl;
  const isDownLoadPdfRef = useRef(isDownLoadPdf);
  const getType = new URLSearchParams(window.location.search).get("type") || "";
  const initialOptionsPaypal = {
    clientId: process.env.REACT_APP_PAYPAL_LIVE_CLIENT_ID,
    currency: "USD",
    intent: "capture",
  };
  const couponRef = useRef();
  isDownLoadPdfRef.current = isDownLoadPdf;
  useEffect(() => {
    const articleID = router.pathname.split("/")[2];
    if (getType === "newVersion") {
      getArticleNewVersion();
    } else if (articleID) {
      dispatch({ type: "SET_LOADER", payload: true });
      setTimeout(function () {
        getArticleDetail(articleID);
        dispatch({ type: "SET_LOADER", payload: false });
      }, 1500);
    }
    offerList();
  }, []);

  useEffect(() => {
    if (finalPaymentDtl.finalAmt < 0) {
      setfinalPaymentDtl({ ...finalPaymentDtl, finalAmt: 0 });
    }
  }, [finalPaymentDtl]);

  const getArticleNewVersion = async () => {
    const articleID = router.pathname.split("/")[2];
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      articleId: articleID,
    };
    const response = await createNewArticleVersion(headers, params);
    if (response?.status === 200) {
      console.log("resonse:", response);
      getArticleDetail(response?.data?.data?._id);
      handleRedirect("", `/manage-payment/${response?.data?.data?._id}`);
    } else {
      return toast.error("Please try again!!");
    }
  };

  const publishArticleAPICall = async () => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const params = {
      id: finalPaymentDtl.id,
      peStatus: "published",
      peId: finalPaymentDtl.Peid,
    };
    // console.log("params",params);
    const response = await acceptRejectArticle(headers, params);
    if (response?.status === 200) {
    } else {
      return toast.error("Something went wrong. Please contact with admin");
    }
  };

  async function getArticleDetail(id) {
    //

    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { articleId: id },
      headers: headers,
    };

    getArticleById(queryParams);
  }
  const sucessHandlerUpdatePayment = (info) => {
    const paymentpoup = paymentFailedPopup;
    if (info.status === 200) {
      if (isInitialPayment === true) {
        if (info.data?.data?.initialPayment === true) {
          const act = activeTabs;
          act.paymentDetail = false;
          act.success = true;
          setactiveTabs({ ...act });
        } else {
          paymentpoup.status = true;
          setpaymentFailedPopup({ ...paymentpoup });
        }
      } else {
        if (info.data?.data?.finalPayment === true) {
          const act = activeTabs;
          act.paymentDetail = false;
          act.success = true;
          setactiveTabs({ ...act });
          // Sync the newly generated slug from the backend response so the
          // "Continue" button navigates to the correct published article URL
          // immediately, without requiring a page reload.
          if (info.data?.data?.slug) {
            setarticleDetail(prev => ({ ...prev, slug: info.data.data.slug }));
          }
          if (articleDetail?.updateFlow !== true) {
            setFinalPaymentStatus(true);
          }
        } else if (finalPaymentDtl.finalAmt === 0) {
        } else {
          paymentpoup.status = true;
          setpaymentFailedPopup({ ...paymentpoup });
        }
      }
      window.scroll({ top: 0, behavior: "smooth" });
    }
  };

  const { mutate: updatePaymentStatus } = updatePayment(
    sucessHandlerUpdatePayment,
  );
  const sucessHandlerPayment = (info) => {
    if (info.status === 200) {
      dispatch({ type: "SET_LOADER", payload: true });
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_PAYMENT_SCRIPT;
      script.id = "paymentScript";
      script.async = true;
      if (!document.getElementById("paymentScript"))
        document.body.appendChild(script);
      setTimeout(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        var easebuzzCheckout = new EasebuzzCheckout(
          process.env.REACT_APP_PAYMENT_KEY,
          process.env.REACT_APP_PAYMENT_MODE,
        );
        var options = {
          access_key: info.data.data, // access key received via Initiate Payment
          onResponse: (response) => {
            updatePaymentData(response, info.data.data);
          },
          theme: "#123456", // color hex
        };
        easebuzzCheckout.initiatePayment(options);
      }, 1000);
    }
  };

  function updatePaymentData(response, access_key) {
    const paymentpoup = paymentFailedPopup;
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    let payStatus = false;
    if (response.status === "success") payStatus = true;
    let payloads = {
      strike: amountToPay.initialStrike,
      couponCode: initialPaymentDtl.couponCode,
      couponAmt: initialPaymentDtl.couponAmt,
      isCouponApplied: initialPaymentDtl.isCouponApplied,
      currencyType: amountToPay.currencyType,
      paymentMode: (response.card_type === "UPI" || response.card_type === "upi") ? "vkUPI" : response.card_type,
      txnid: response.txnid,
      initialPayment: payStatus,
      articleId: articleDetail._id,
      data: access_key,
      status: response.status,
      gst: isMWP
        ? mwpValues.gstVal.toFixed(2)
        : ((18 / 100) * initialPaymentDtl.initialAmt).toFixed(2),
      payableAmount: isMWP
        ? mwpValues.netPayable.toFixed(2)
        : (
          initialPaymentDtl.initialAmt +
          (18 / 100) * amountToPay.initialAmt
        ).toFixed(2),
      lastPrice: amountToPay.listPriceInitial,
    };
    if (isInitialPayment === false) {
      payloads = {
        strike: amountToPay.finalStrike,
        couponCode: finalPaymentDtl.couponCode,
        couponAmt: finalPaymentDtl.couponAmt,
        isCouponApplied: finalPaymentDtl.isCouponApplied,
        grantAmount: finalPaymentDtl.grantAmount,
        isGrantApplied: finalPaymentDtl.isGrantApplied,
        mudraAmnt: finalPaymentDtl.mudraAmnt,
        isMudraApplied: finalPaymentDtl.isMudraApplied,
        currencyType: amountToPay.currencyType,
        finalPaymentAmount:
          handleGstPayment(finalPaymentDtl.finalAmt.toFixed(2)) + ".00",
        paymentMode: (response.card_type === "UPI" || response.card_type === "upi") ? "vkUPI" : response.card_type,
        finalPaymentTxId: response.txnid,
        txnid: response.txnid,
        finalPayment: payStatus,
        articleId: articleDetail._id,
        data: access_key,
        status: response.status,
        gst: "0.00",
        total: finalPaymentDtl.finalAmt,
        payableAmount:
          handleGstPayment(finalPaymentDtl.finalAmt.toFixed(2)) + ".00",
        introductryPrice: amountToPay.finalAmt,
        lastPrice: amountToPay.listpriceFinal,
      };

      if (finalPaymentDtl.isMudraApplied === true)
        payloads.mudras = finalPaymentDtl.mudraAmnt;
      if (finalPaymentDtl.isCouponApplied === true) {
        payloads.couponAmount = finalPaymentDtl.couponAmt;
        payloads.offerCode = finalPaymentDtl.couponCode;
      }
    }
    const queryParams = {
      payload: payloads,
      headers,
    };
    updatePaymentStatus(queryParams);
    paymentpoup.txnId = response.txnid;
    paymentpoup.card_type = response.card_type;
    setpaymentFailedPopup({ ...paymentpoup });
  }
  const handleGstPayment = (amt) => {
    let finalAmt = "";
    let totalAmt = amt.split(".");
    if (totalAmt[1] > 50) {
      finalAmt = Number(totalAmt[0]) + 1;
    } else {
      finalAmt = totalAmt[0];
    }
    return finalAmt;
  };

  const { mutate: iniitatePayment } = iniitatePayments(sucessHandlerPayment);
  const sucessHandler = (articleDetails) => {
    try {
      if (articleDetails?.status === 200 && articleDetails?.data?.data) {
        const editDetl = articleDetails.data.data;
        if (editDetl.validCouponCode && editDetl.validCouponCode._id) {
          setinitialPaymentDtl((prev) => ({
            ...prev,
            isCouponApplied: true,
            couponCode: editDetl.validCouponCode.offerCode,
            couponId: editDetl.validCouponCode._id,
            couponAmt: editDetl.validCouponCode.value,
          }));
        }

        const mwpJName = editDetl?.submissionDetail?.journalName?.trim()?.toLowerCase();
        const isMWP =
          (mwpJName === "minorities in world politics" ||
           mwpJName === "community learning and social transformation" ||
           mwpJName === "applied and basic obesity, diabetes and endocrinology" ||
           editDetl?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
           editDetl?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");

        if (editDetl.finalPayment === true) {
          const payment = { ...finalPaymentDtl };
          if (articleDetails?.data?.currentStatus?.[0]) {
            payment.id = articleDetails.data.currentStatus[0]._id;
            payment.Peid = articleDetails.data.currentStatus[0].peId?.[0] || "";
          }
          setfinalPaymentDtl(payment);
          setisInitialPayment(false);
          setFinalPaymentStatus(true);
          const act = { ...activeTabs };
          act.paymentDetail = false;
          act.success = true;
          setactiveTabs(act);
        } else if (isMWP && editDetl.finalPayment === false) {
          const payment = { ...finalPaymentDtl };
          if (
            editDetl?.grantDetails?.amount > 0 &&
            editDetl?.grantDetails?.grantStatus === "approved"
          ) {
            payment.grantAmount = editDetl?.grantDetails?.amount;
            payment.isGrantApplied = true;
          }
          if (articleDetails?.data?.currentStatus?.[0]) {
            payment.id = articleDetails.data.currentStatus[0]._id;
            payment.Peid = articleDetails.data.currentStatus[0].peId?.[0] || "";
          }
          setfinalPaymentDtl(payment);
          setisInitialPayment(true);
          const act = { ...activeTabs };
          act.paymentDetail = true;
          act.success = false;
          setactiveTabs(act);
          getUserMudra();
          offerList();
        } else if (
          !isMWP &&
          (editDetl.status === "approved" || editDetl.updateFlow === true) &&
          editDetl.finalPayment === false
        ) {
          const payment = { ...finalPaymentDtl };
          if (
            editDetl?.grantDetails?.amount > 0 &&
            editDetl?.grantDetails?.grantStatus === "approved"
          ) {
            payment.grantAmount = editDetl?.grantDetails?.amount;
            payment.isGrantApplied = true;
          }
          if (editDetl.updateFlow === false) {
            if (articleDetails?.data?.currentStatus?.[0]) {
              payment.id = articleDetails.data.currentStatus[0]._id;
              payment.Peid = articleDetails.data.currentStatus[0].peId?.[0] || "";
            }
          }
          setfinalPaymentDtl(payment);

          setisInitialPayment(false);

          getUserMudra();
          offerList();
        } else if (editDetl.initialPayment === true) {
          const act = { ...activeTabs };
          act.paymentDetail = false;
          act.success = true;
          setactiveTabs(act);
        }

        const couponAmt = editDetl.validCouponCode?.value || 0;
        handleAPCData(editDetl?.reviewType?.typeOfReview, editDetl, couponAmt);
        setarticleDetail(editDetl);
      } else {
        setisPageLoaded(true);
      }
    } catch (err) {
      console.error("Error in sucessHandler:", err);
      setisPageLoaded(true);
    }
  };

  useEffect(() => {
    if (isPageLoaded && articleDetail && isInitialPayment) {
      const isSocietyFunded = articleDetail?.paymentBySociety?.apcPayBySociety;
      const isCouponValid = initialPaymentDtl.isCouponApplied;
      const amountToPayZero = initialPaymentDtl.initialAmt === 0;

      if (
        isSocietyFunded &&
        isCouponValid &&
        amountToPayZero &&
        !activeTabs.success
      ) {
        paymentInitiation();
      }
    }
  }, [isPageLoaded, articleDetail, initialPaymentDtl.initialAmt]);

  const handleAPCData = async (reviewType, editDetl, couponAmt = 0) => {
    try {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const params = {
        typeOfApc: user?.nationality || "withInIndia",
      };
      const response = await getAPCValues(headers, params);
      if (response?.status === 200) {
        const data = response?.data?.data || [];
        const amt = { ...amountToPay };
        const finl = { ...finalPaymentDtl };

        const d0 = data?.[0] || {};
        const d1 = data?.[1] || {};
        const d2 = data?.[2] || {};
        const d3 = data?.[3] || {};

        const societyJournalID = "6454a6390d88e62fa10503bf";
        const megaJournalID = "6454a6390d88e62fa10503be";
        const conferenceArticleTypeID = "664aed76ada7b4f743b760a9";
        const isSocietyJournal =
          editDetl?.submissionDetail?.journalType?._id === societyJournalID ||
          editDetl?.submissionDetail?.journalType === societyJournalID;
        const isMegaJournal =
          editDetl?.submissionDetail?.journalType?._id === megaJournalID ||
          editDetl?.submissionDetail?.journalType === megaJournalID;
        const isConferencePaper =
          editDetl?.submissionDetail?.articleType?._id === conferenceArticleTypeID ||
          editDetl?.submissionDetail?.articleType === conferenceArticleTypeID;

        const mwpJName2 = editDetl?.submissionDetail?.journalName?.trim()?.toLowerCase();
        const isMWP =
          (mwpJName2 === "minorities in world politics" ||
           mwpJName2 === "community learning and social transformation" ||
           mwpJName2 === "applied and basic obesity, diabetes and endocrinology" ||
           editDetl?.submissionDetail?.journalType?._id === societyJournalID ||
           editDetl?.submissionDetail?.journalType === societyJournalID);

        if (isMWP && isSocietyJournal && isConferencePaper) {
          amt.initialAmt = societyConferenceBaseAPC;
        } else if (isMWP) {
          amt.initialAmt = 6500;
        } else if ((isSocietyJournal || isMegaJournal) && !isConferencePaper) {
          amt.initialAmt = 1000;
        } else if (isConferencePaper) {
          amt.initialAmt = d3.introductoryPrice || 1000;
        } else {
          amt.initialAmt = d1.introductoryPrice || 1000;
        }
        amt.initialStrike = d2.strike || false;
        amt.listPriceInitial = d2.lastPrice || 0;
        amt.currencyType = user?.nationality === "outSideIndia" ? "USD" : "INR";

        if (isMegaJournal) {
          amt.finalAmt = 3999;
          amt.listpriceFinal = 3999;
          amt.finalStrike = false;
          finl.finalAmt = Math.max(0, 3999 - (finl.isCouponApplied ? (finl.couponAmt || 0) : 0));
        } else if (reviewType === "only post-publication open review") {
          amt.finalAmt = d0.introductoryPrice || 3999;
          amt.listpriceFinal = d1.lastPrice || 6000;
          amt.finalStrike = d1.strike || false;
          finl.finalAmt = amt.finalAmt - finl.grantAmount - amt.initialAmt;
        } else {
          amt.finalAmt = d0.introductoryPrice || 3999;
          amt.listpriceFinal = d0.lastPrice || 6000;
          amt.finalStrike = d0.strike || false;
          finl.finalAmt = amt.finalAmt - finl.grantAmount - amt.initialAmt;
        }

        setfinalPaymentDtl(finl);
        setamountToPay(amt);
        setinitialPaymentDtl((prev) => ({
          ...prev,
          initialAmt: isMWP ? amt.initialAmt : Math.max(0, amt.initialAmt - couponAmt),
        }));
      }
    } catch (err) {
      console.error("Error in handleAPCData:", err);
    } finally {
      setisPageLoaded(true);
    }
  };
  const { mutate: getArticleById } = FetchArticleById(sucessHandler);

  function paymentInitiation() {
    if (!isInitialPayment && !finalPaymentDtl.isTermAccept) {
      return toast.error("Please accept the Terms & Conditions to proceed.");
    }
    const { id } = jwt_decode(localStorage.usertoken);
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const redairectTo = isInitialPayment === false
      ? `${SERVER_URL}/api/article/approvePrPaymentCallback`
      : `${SERVER_URL}/dashboard/edit-article/${articleDetail._id}`;
    let amnt;

    if (activeTabs.paymentDetail === true && isInitialPayment === true) {
      if (isMWP) {
        amnt = mwpValues.netPayable.toFixed(2);
      } else if (user?.nationality === "withInIndia") {
        amnt = Math.max(
          0,
          amountToPay.initialAmt +
          (18 / 100) * amountToPay.initialAmt -
          initialPaymentDtl.couponAmt,
        ).toFixed(2);
      } else {
        amnt = Math.max(
          0,
          amountToPay.initialAmt - initialPaymentDtl.couponAmt,
        ).toFixed(2);
      }
      // console.log(amnt, "amount");
    } else if (
      activeTabs.paymentDetail === true &&
      isInitialPayment === false
    ) {
      if (isMegaJournal) {
        amnt = finalPaymentDtl.finalAmt.toFixed(2);
      } else if (user?.nationality === "withInIndia") {
        amnt = handleGstPayment(
          (
            finalPaymentDtl.finalAmt +
            (18 / 100) * finalPaymentDtl.finalAmt
          ).toFixed(2),
        );
      } else {
        amnt = finalPaymentDtl.finalAmt.toFixed(2);
      }
      // console.log(amnt, "amount");
    } else if (activeTabs.success === true && isInitialPayment === true) {
      if (user?.nationality === "withInIndia") {
        amnt =
          amountToPay.initialAmt +
          (18 / 100) * amountToPay.initialAmt -
          initialPaymentDtl.couponAmt;
      } else {
        amnt = finalPaymentDtl.finalAmt.toFixed(2);
      }
      // console.log(amnt, "amount");
    } else {
      if (user?.nationality === "withInIndia") {
        amnt = (
          amountToPay.initialAmt +
          (18 / 100) * amountToPay.initialAmt
        ).toFixed(2);
      } else {
        amnt = amountToPay.initialAmt.toFixed(2);
      }
      // console.log(amnt, "amount");
    }

    if (amnt < 0 && amountToPay.currencyType == "INR") {
      amnt = "1.0";
    } else if (amnt < 0 && amountToPay.currencyType == "USD") {
      amnt = "0.10";
    }
    console.log(amnt);
    const payloads = {
      key: process.env.REACT_APP_PAYMENT_KEY,
      amount: amnt,
      productinfo: "Create Article Fee",
      firstname: user.fullName,
      phone: user.phoneNumber,
      email: user.email,
      surl: `${redairectTo}`,
      furl: `${redairectTo}?type=failed`,
      salt: process.env.REACT_APP_PAYMENT_SALT,
      udf1: articleDetail._id,
      udf2: "",
      udf3: "",
      udf4: "",
      udf5: "",
      udf6: "",
      udf7: "",
      udf8: "",
      udf9: "",
      udf10: "",
      userId: id,
      articleId: articleDetail._id,
    };
    var formBody = [];
    for (var property in payloads) {
      var encodedKey = encodeURIComponent(property);
      var encodedValue = encodeURIComponent(payloads[property]);
      formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    const queryParams = {
      payload: formBody,
      headers,
    };
    if (initialPaymentDtl.initialAmt === 0 || (isMWP && mwpValues.netPayable === 0)) {
      let payloads = {
        txnid: "abcd-efghij-klmnop",
        payableAmount: "0.00",
        amount: isMWP
          ? (mwpValues.deductedAPC + mwpValues.gstVal).toFixed(2)
          : (
            amountToPay.initialAmt +
            (18 / 100) * amountToPay.initialAmt
          ).toFixed(2),
        email: user.email,
        firstname: user.fullName,
        couponCode: initialPaymentDtl.couponCode,
        productinfo: "Create Article Fee",
        userId: id,
        articleId: articleDetail._id,
        paymentMode: "Free",
        initialPayment: true,
        status: "success",
        gst: isMWP
          ? mwpValues.gstVal.toFixed(2)
          : ((18 / 100) * amountToPay.initialAmt).toFixed(2),
      };
      const queryParams = {
        payload: payloads,
        headers,
      };
      updatePaymentStatus(queryParams);

      const paymentpoup = paymentFailedPopup;
      paymentpoup.txnId = "abcd-efghij-klmnop";
      paymentpoup.card_type = "Free";
      setpaymentFailedPopup({ ...paymentpoup });

      const act = activeTabs;
      act.paymentDetail = false;
      act.success = true;
      setactiveTabs({ ...act });
    } else if (isInitialPayment === false && finalPaymentDtl.finalAmt === 0) {
      const payloads = {
        productinfo: "Create Article Fee",
        amount: amnt,
        firstname: user.fullName,
        email: user.email,
        userId: id,
        strike: amountToPay.finalStrike,
        couponCode: finalPaymentDtl.couponCode,
        couponAmt: finalPaymentDtl.couponAmt,
        isCouponApplied: finalPaymentDtl.isCouponApplied,
        grantAmount: finalPaymentDtl.grantAmount,
        isGrantApplied: finalPaymentDtl.isGrantApplied,
        mudraAmnt: finalPaymentDtl.mudraAmnt,
        isMudraApplied: finalPaymentDtl.isMudraApplied,
        currencyType: amountToPay.currencyType,
        finalPaymentAmount:
          handleGstPayment(finalPaymentDtl.finalAmt.toFixed(2)) + ".00",
        paymentMode: "Free",
        finalPayment: true,
        articleId: articleDetail._id,
        status: "success",
        gst: "0.00",
        total: finalPaymentDtl.finalAmt,
        payableAmount:
          handleGstPayment(finalPaymentDtl.finalAmt.toFixed(2)) + ".00",
        introductryPrice: amountToPay.finalAmt,
        lastPrice: amountToPay.listpriceFinal,
      };
      if (finalPaymentDtl.isMudraApplied === true)
        payloads.mudras = finalPaymentDtl.mudraAmnt;
      if (finalPaymentDtl.isCouponApplied === true) {
        payloads.couponAmount = finalPaymentDtl.couponAmt;
        payloads.offerCode = finalPaymentDtl.couponCode;
      }
      const queryParams = {
        payload: payloads,
        headers,
      };
      updatePaymentStatus(queryParams);
      const act = activeTabs;
      act.paymentDetail = false;
      act.success = true;
      setactiveTabs({ ...act });
      if (articleDetail?.updateFlow !== true) {
        setFinalPaymentStatus(true);
      }
    } else {
      iniitatePayment(queryParams);
    }
  }
  const handleRedirect = (e, path) => {
    if (e !== "") e.preventDefault();
    navigate(path);
  };
  function handleFullCharge(e) {
    const act = activeTabs;
    if (e.target.checked) act.aggryToc = true;
    else act.aggryToc = false;
    setactiveTabs({ ...act });
  }
  function getReceipt(e) {
    const act = activeTabs;
    if (e.target.checked) {
      act.getReceipt = true;
      downLoadReciepts("email");
    } else {
      act.getReceipt = false;
    }

    setactiveTabs({ ...act });
  }

  async function continueWithArticle() {
    if (isMWP) {
      dispatch({ type: "SET_LOADER", payload: true });
      try {
        const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
        const res = await publishFromAdminSideApi(headers, {}, articleDetail._id);
        dispatch({ type: "SET_LOADER", payload: false });
        if (res.status === 200) {
          if (res.data?.data?.updatedArticle) {
            setarticleDetail(prev => ({ ...prev, slug: res.data.data.updatedArticle.slug }));
          }
          setMwpPublishedModal(true);
        } else {
          toast.error("Failed to publish the article. Please try again.");
        }
      } catch (e) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.error("Error publishing article:", e);
        toast.error("An error occurred while publishing the article.");
      }
      return;
    }

    if (
      activeTabs.aggryToc === true &&
      activeTabs.getReceipt === true &&
      isInitialPayment === true
    )
      setpaymentSuccess(true);
    else if (isInitialPayment === false) setarticlePublishedModal(true);
    else handleRedirect("", `/dashboard/edit-article/${articleDetail._id}`);
  }

  const handleOkayClick = async () => {
    setarticlePublishedModal(false);
    try {
      if (articleDetail?._id) {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage?.usertoken}`,
        };
        await fetch(`${SERVER_URL}/AakashGanga/sendAdminPaymentEmail`, {
          method: "POST",
          headers,
          body: JSON.stringify({ articleId: articleDetail._id }),
        });
      }
    } catch (err) {
      console.error("Error sending admin payment email:", err);
    }
    navigate("/myArticle/submit", { state: "submit" });
  };
  const sucessHandlerDownLoadReceipt = (details) => {
    if (details.status === 200) {
      if (isDownLoadPdfRef.current === true) {
        const url = details.data.data;
        let filename = "initialPaymentReceipt";
        if (isInitialPayment === false) filename = "finalPaymentReceipt";
        downLoadFile(url, `${filename}${paymentFailedPopup.txnId}.pdf`);
      }
    }
  };
  const { mutate: downloadSendReceipt } = downloadOrsendReceipt(
    sucessHandlerDownLoadReceipt,
  );

  function downLoadReciepts(type) {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const payloads = { articleId: articleDetail._id };
    if (isInitialPayment === false) payloads.finalPayment = true;
    else payloads.initialPayment = true;
    if (type === "email") {
      setisDownLoadPdf(false);
      payloads.email = true;
    } else if (type === "download") {
      payloads.download = true;
      setisDownLoadPdf(true);
    }

    const queryParams = {
      payload: payloads,
      headers,
    };
    downloadSendReceipt(queryParams);
  }

  const sucessHandlerAllOffer = (details) => {
    if (details.status === 200) {
      setoffers(details.data.data);
    }
  };

  function offerList() {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { limit: 100, page: 1, availablefor: "public" },
      headers: headers,
    };

    getALLOfferForPayment(queryParams);
  }
  const { mutate: getALLOfferForPayment } = FetchAllOfferForPayment(
    sucessHandlerAllOffer,
  );
  const sucessHandlerMudraByUserId = (details) => {
    if (details.status === 200) {
      if (details.data.mudras > 0) setmudras(details.data.mudras);
    }
  };
  function getUserMudra() {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const { id } = jwt_decode(localStorage.usertoken);
    const queryParams = {
      params: { userId: id },
      headers: headers,
    };

    getMudraByUserId(queryParams);
  }
  const { mutate: getMudraByUserId } = FetchMudraByUserId(
    sucessHandlerMudraByUserId,
  );
  function convertDateFormate(date) {
    let newDate = new Date(date);
    let getDate = newDate.getDate();
    let getYear = newDate.getFullYear();
    let getMonth = newDate.toLocaleString("en-US", { month: "short" });
    return getDate + " " + getMonth + " " + getYear;
  }

  function copyCouponCode(code) {
    copy(code);
    return toast.success("Copied");
  }
  function applyMudra() {
    const payDetl = finalPaymentDtl;
    payDetl.isMudraApplied = true;
    payDetl.mudraAmnt = mudras;
    payDetl.finalAmt = finalPaymentDtl.finalAmt - mudras;
    setfinalPaymentDtl({ ...payDetl });
  }
  function removeMudra() {
    const payDetl = finalPaymentDtl;
    payDetl.isMudraApplied = false;
    payDetl.mudraAmnt = 0;
    payDetl.finalAmt = finalPaymentDtl.finalAmt + parseInt(mudras);
    setfinalPaymentDtl({ ...payDetl });
  }
  const sucessHandlerMudras = (details) => {
    console.log("details==>", details);
    if (details.status === 200) {
      console.log("journalName", articleDetail?.submissionDetail?.journalName);
      const detail = details.data.data;
      if (detail?._id) {
        const megaJournalID = "6454a6390d88e62fa10503be";
        const isMegaJournal =
          articleDetail?.submissionDetail?.journalType?._id === megaJournalID ||
          articleDetail?.submissionDetail?.journalType === megaJournalID;
        console.log("isMegaJournal", isMegaJournal);
        console.log(
          "journalName",
          articleDetail?.submissionDetail?.journalName,
        );
        if (isMegaJournal) {
          const journalName = articleDetail?.submissionDetail?.journalName;
          if (
            !detail?.megaJournalType ||
            (detail?.megaJournalType !== "All" &&
              journalName !== "All" &&
              detail?.megaJournalType !== journalName)
          ) {
            return toast.error("Coupon code is incorrect.");
          }
        }
        // Society journal coupon validation
        const societyJournalID = "6454a6390d88e62fa10503bf";
        const isSocietyJournal =
          articleDetail?.submissionDetail?.journalType?._id === societyJournalID ||
          articleDetail?.submissionDetail?.journalType === societyJournalID;
        if (isSocietyJournal) {
          const journalName = articleDetail?.submissionDetail?.journalName;
          if (
            !detail?.societyJournalType ||
            (detail.societyJournalType !== "All" &&
              journalName !== "All" &&
              detail.societyJournalType !== journalName)
          ) {
            return toast.error(
              `This coupon is not valid for "${journalName}". Please use a coupon issued for this society journal.`
            );
          }
        }
        const atToPay = { ...amountToPay };
        const payment = { ...finalPaymentDtl };
        payment.isCouponApplied = true;
        payment.couponCode = detail.offerCode;
        payment.couponId = detail?._id;
        payment.couponAmt = detail.value;

        if (isMegaJournal) {
          payment.finalAmt = Math.max(0, 3999 - detail.value);
        } else {
          const baseAmt = amountToPay.finalAmt - (payment.grantAmount || 0) - amountToPay.initialAmt;
          payment.finalAmt = Math.max(0, baseAmt - detail.value);
        }
        setfinalPaymentDtl(payment);
        setamountToPay(atToPay);
      } else {
        toast.error("invalid coupon code!");
      }
    }
  };
  const sucessHandlerMudrasRes = (details) => {
    // console.log("details==>",details)
    if (details.status === 200) {
      const detail = details.data.data;
      if (detail?._id) {
        const megaJournalID = "6454a6390d88e62fa10503be";
        const isMegaJournal =
          articleDetail?.submissionDetail?.journalType?._id === megaJournalID ||
          articleDetail?.submissionDetail?.journalType === megaJournalID;
        console.log("isMegaJournal", isMegaJournal);
        console.log(
          "journalName",
          articleDetail?.submissionDetail?.journalName,
        );
        if (isMegaJournal) {
          const journalName = articleDetail?.submissionDetail?.journalName;
          if (
            !detail?.megaJournalType ||
            (detail?.megaJournalType !== "All" &&
              journalName !== "All" &&
              detail?.megaJournalType !== journalName)
          ) {
            console.log(
              "journalName",
              articleDetail?.submissionDetail?.journalName,
            );
            return toast.error("Coupon code is incorrect.");
          }
        }
        // Society journal coupon validation
        const societyJournalID = "6454a6390d88e62fa10503bf";
        const isSocietyJournal =
          articleDetail?.submissionDetail?.journalType?._id === societyJournalID ||
          articleDetail?.submissionDetail?.journalType === societyJournalID;
        if (isSocietyJournal) {
          const journalName = articleDetail?.submissionDetail?.journalName;
          if (
            !detail?.societyJournalType ||
            (detail.societyJournalType !== "All" &&
              journalName !== "All" &&
              detail.societyJournalType !== journalName)
          ) {
            return toast.error(
              `This coupon is not valid for "${journalName}". Please use a coupon issued for this society journal.`
            );
          }
        }
        const inPyDtl = initialPaymentDtl;
        inPyDtl.isCouponApplied = true;
        inPyDtl.couponCode = detail.offerCode;
        inPyDtl.couponId = detail?._id;
        inPyDtl.couponAmt = detail.value;
        const mwpJName3 = articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase();
        const isMWP =
          (mwpJName3 === "minorities in world politics" ||
           mwpJName3 === "community learning and social transformation" ||
           mwpJName3 === "applied and basic obesity, diabetes and endocrinology" ||
           articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
           articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
        inPyDtl.initialAmt = isMWP ? inPyDtl.initialAmt : Math.max(0, inPyDtl.initialAmt - detail.value);
        setinitialPaymentDtl({ ...inPyDtl });
      } else {
        toast.error("invalid coupon code!");
      }
    }
  };
  const { mutate: getOfferByIdRes } = FetchOfferById(sucessHandlerMudrasRes);
  const { mutate: getOfferById } = FetchOfferById(sucessHandlerMudras);

  function applyCouponRes() {
    if (couponRef.current.value !== "") {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        params: {
          offerCode: couponRef.current.value,
          articleId: articleDetail._id,
        },
        headers: headers,
      };
      getOfferByIdRes(queryParams);
    }
  }

  function applyCoupon() {
    if (couponRef.current.value !== "") {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        params: { offerCode: couponRef.current.value },
        headers: headers,
      };
      getOfferById(queryParams);
    }
  }
  function removeCouponCode() {
    const megaJournalID = "6454a6390d88e62fa10503be";
    const isMegaJournal =
      articleDetail?.submissionDetail?.journalType?._id === megaJournalID ||
      articleDetail?.submissionDetail?.journalType === megaJournalID;
    const payment = { ...finalPaymentDtl };
    payment.isCouponApplied = false;
    payment.couponCode = "";
    payment.couponId = "";
    payment.couponAmt = 0;
    if (isMegaJournal) {
      payment.finalAmt = 3999;
    } else {
      const baseAmt = amountToPay.finalAmt - (payment.grantAmount || 0) - amountToPay.initialAmt;
      payment.finalAmt = Math.max(0, baseAmt);
    }
    setfinalPaymentDtl(payment);
  }

  function removeCouponCodeRes() {
    const payment = initialPaymentDtl;
    // const atToPay=amountToPay;
    // atToPay.initialAmt=atToPay.initialAmt+parseInt(payment.couponAmt)
    const mwpJName4 = articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase();
    const isMWP =
      (mwpJName4 === "minorities in world politics" ||
       mwpJName4 === "community learning and social transformation" ||
       mwpJName4 === "applied and basic obesity, diabetes and endocrinology" ||
       articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
       articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
    payment.initialAmt = isMWP ? payment.initialAmt : payment.initialAmt + parseInt(payment.couponAmt);
    payment.isCouponApplied = false;
    payment.couponCode = "";
    payment.couponId = "";
    payment.couponAmt = "";

    // setamountToPay({...atToPay})
    setinitialPaymentDtl({ ...payment });
  }
  function acceptToc(e) {
    const payment = finalPaymentDtl;
    if (e.target.checked) payment.isTermAccept = true;
    else payment.isTermAccept = false;
    setfinalPaymentDtl({ ...payment });
  }

  function createOrder(data, actions) {
    let amnt = (amountToPay.initialAmt - finalPaymentDtl.couponAmt).toFixed(2);
    if (isInitialPayment === false)
      amnt = (
        finalPaymentDtlRef.current.finalAmt - finalPaymentDtl.couponAmt
      ).toFixed(2);
    // let amnt=(amountToPay.initialAmt +(18/100)*amountToPay.initialAmt-finalPaymentDtl.couponAmt).toFixed(2);
    if (amnt < 0 && amountToPay.currencyType == "INR") {
      amnt = "1.0";
    } else if (amnt < 0 && amountToPay.currencyType == "USD") {
      amnt = "0.10";
    }
    // console.log(amnt,'amntamnt')
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: amnt,
          },
        },
      ],
    });
  }
  function onApprove(data) {
    const paymentpoup = paymentFailedPopup;
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    let payStatus = true;

    let payloads = {
      userId: user._id,
      strike: amountToPay.initialStrike,
      currencyType: amountToPay.currencyType,
      paymentMode: data.paymentSource,
      txnid: data.paymentID,
      initialPayment: true,
      articleId: articleDetail._id,
      data: data.orderID,
      status: "success",
      gst: 0,
      payableAmount: amountToPay.initialAmt.toFixed(2),
      lastPrice: amountToPay.listPriceInitial,
    };
    if (isInitialPayment === false) {
      if (articleDetail?.updateFlow === false) setFinalPaymentStatus(true);
      payloads = {
        userId: user._id,
        strike: amountToPay.finalStrike,
        couponCode: finalPaymentDtl.couponCode,
        couponAmt: finalPaymentDtl.couponAmt,
        isCouponApplied: finalPaymentDtl.isCouponApplied,
        grantAmount: finalPaymentDtl.grantAmount,
        isGrantApplied: finalPaymentDtl.isGrantApplied,
        mudraAmnt: finalPaymentDtl.mudraAmnt,
        isMudraApplied: finalPaymentDtl.isMudraApplied,
        currencyType: amountToPay.currencyType,
        finalPaymentAmount: finalPaymentDtl.finalAmt.toFixed(2),
        paymentMode: data.paymentSource,
        finalPaymentTxId: data.paymentID,
        txnid: data.paymentID,
        finalPayment: true,
        articleId: articleDetail._id,
        data: data.orderID,
        status: "success",
        gst: 0,
        total: finalPaymentDtl.finalAmt,
        payableAmount: finalPaymentDtl.finalAmt.toFixed(2),
        introductryPrice: amountToPay.finalAmt,
        lastPrice: amountToPay.listpriceFinal,
      };

      if (finalPaymentDtl.isMudraApplied === true)
        payloads.mudras = finalPaymentDtl.mudraAmnt;
      if (finalPaymentDtl.isCouponApplied === true) {
        payloads.couponAmount = finalPaymentDtl.couponAmt;
        payloads.offerCode = finalPaymentDtl.couponCode;
      }
    }

    const queryParams = {
      payload: payloads,
      headers,
    };
    updatePaymentStatus(queryParams);
    paymentpoup.txnId = data.paymentID;
    paymentpoup.card_type = data.paymentSource;
    setpaymentFailedPopup({ ...paymentpoup });
  }
  function onCancelPayapl(data) {
    console.log("onCancelPayapl", data);
  }
  function onErrorPayapl(data) {
    console.log("onErrorPayapl", data);
  }

  const mwpJName5 = articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase();
  const isMWP =
    (mwpJName5 === "minorities in world politics" ||
     mwpJName5 === "community learning and social transformation" ||
     mwpJName5 === "applied and basic obesity, diabetes and endocrinology" ||
     articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
     articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");

  const megaJournalID = "6454a6390d88e62fa10503be";
  const isMegaJournal =
    articleDetail?.submissionDetail?.journalType?._id === megaJournalID ||
    articleDetail?.submissionDetail?.journalType === megaJournalID;

  const isSocietyConferencePaper =
    (articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
     articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf") &&
    (articleDetail?.submissionDetail?.articleType?._id === "664aed76ada7b4f743b760a9" ||
     articleDetail?.submissionDetail?.articleType === "664aed76ada7b4f743b760a9");

  const getMWPValues = () => {
    const couponAmt = initialPaymentDtl.couponAmt || 0;
    if (isSocietyConferencePaper) {
      // Society conference papers: INR 2999 inclusive of 18% GST
      const baseAPC = societyConferenceBaseAPC;
      const gstVal = Number((societyConferenceTotal - baseAPC).toFixed(2));
      const sgstVal = Number((gstVal / 2).toFixed(2));
      const cgstVal = Number((gstVal - sgstVal).toFixed(2));
      const netPayable = Math.max(0, societyConferenceTotal - couponAmt);
      return { deductedAPC: baseAPC, gstVal, sgstVal, cgstVal, netPayable };
    }
    const baseAPC = 6500;
    const gstVal = Math.round(baseAPC * 0.18);
    const sgstVal = Math.round(baseAPC * 0.09);
    const cgstVal = Math.round(baseAPC * 0.09);
    const netPayable = Math.max(0, baseAPC + gstVal - couponAmt);
    const deductedAPC = baseAPC;
    return { deductedAPC, gstVal, sgstVal, cgstVal, netPayable };
  };

  const mwpValues = getMWPValues();

  return (
    <>
      <Header />
      <div className="inner-pages">
        {isPageLoaded === true && (
          <div className="centerSection">
            {activeTabs.paymentDetail === true && isInitialPayment === true && (
              <div className="registrationPaymentMain">
                <div className="registrationPaymentCard">
                  <div className="registrationPaymentHead">
                    <h3>
                      {isInitialPayment === true
                        ? "Article Registration Payment"
                        : "Final Article Processing Charge"}
                    </h3>
                  </div>
                  {isInitialPayment === true &&
                    !((articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "minorities in world politics" ||
                       articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "community learning and social transformation" ||
                       articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "applied and basic obesity, diabetes and endocrinology" ||
                       articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                       articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf")) && (
                      <div className="registrationPaymentCotts">
                        <div className="questionBox reddot ">
                          <span className="fw-bold removebefore">
                            Pay the initial registration amount of{" "}
                            {amountToPay.currencyType} {amountToPay.initialAmt} to
                            start writing your article immediately
                            <sup className="supStar">*</sup>.
                          </span>
                          <p>
                            <sup className="supStar">*</sup>If your article is not
                            accepted for publishing, the registration amount of{" "}
                            {amountToPay.currencyType} {amountToPay.initialAmt}{" "}
                            will be refunded in your Mudra Kosh (Wallet),
                            <br /> available in your dashboard.
                          </p>
                        </div>
                      </div>
                    )}
                  <div className="registrationMidd">
                    <div className="registrationMiddLeft">
                      <h4>Bill Summary</h4>
                      <ul>
                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>Article Processing Charge</span>
                              <div className="">
                                <b>
                                  {amountToPay.currencyType}{" "}
                                  {isInitialPayment === true
                                    ? amountToPay.initialAmt.toFixed(2)
                                    : amountToPay.finalAmt.toFixed(2)}
                                </b>
                              </div>
                            </div>
                          </div>
                        </li>
                        {user?.nationality === "withInIndia" ? (
                          <>
                            {user?.affiliation?.affiliations?.[0]?.city ==
                              "New Delhi" ? (
                              <>
                                <li>
                                  <div className="listCardBox">
                                    <div className="listCard">
                                      <span>S GST- 9%</span>
                                      <div className="">
                                        <b>
                                          {amountToPay.currencyType}{" "}
                                          {isMWP ? (
                                            mwpValues.sgstVal.toFixed(2)
                                          ) : (
                                            ((9 / 100) * amountToPay.initialAmt).toFixed(2)
                                          )}
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                                <li>
                                  <div className="listCardBox">
                                    <div className="listCard">
                                      <span>C GST- 9%</span>
                                      <div className="">
                                        <b>
                                          {amountToPay.currencyType}{" "}
                                          {isMWP ? (
                                            mwpValues.cgstVal.toFixed(2)
                                          ) : (
                                            ((9 / 100) * amountToPay.initialAmt).toFixed(2)
                                          )}
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </>
                            ) : (
                              <>
                                <li>
                                  <div className="listCardBox">
                                    <div className="listCard">
                                      <span>GST- 18%</span>
                                      <div className="">
                                        <b>
                                          {amountToPay.currencyType}{" "}
                                          {isMWP ? (
                                            mwpValues.gstVal.toFixed(2)
                                          ) : (
                                            ((18 / 100) * amountToPay.initialAmt).toFixed(2)
                                          )}
                                        </b>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              </>
                            )}
                          </>
                        ) : null}

                        {initialPaymentDtl.isCouponApplied === true && (
                          <li className="listCard d-flex justify-content-between">
                            <span>Coupon Applied</span>
                            <div className="">
                              <b>
                                - {amountToPay.currencyType}{" "}
                                {initialPaymentDtl.couponAmt}
                              </b>{" "}
                            </div>
                          </li>
                        )}
                        {finalPaymentDtl.isCouponApplied === true && (
                          <li className="listCard d-flex justify-content-between">
                            <span>Coupon Applied</span>
                            <div className="">
                              <b>
                                - {amountToPay.currencyType}{" "}
                                {finalPaymentDtl.couponAmt}
                              </b>{" "}
                            </div>
                          </li>
                        )}

                        <li>
                          <div className="grandCardBox">
                            <div className="grandCardList">
                              <span className="subTitle">Net Payable</span>
                              {isMWP ? (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {mwpValues.netPayable.toFixed(2)}
                                </b>
                              ) : user?.nationality === "withInIndia" ? (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {Math.max(
                                    0,
                                    amountToPay.initialAmt +
                                    (18 / 100) * amountToPay.initialAmt -
                                    initialPaymentDtl.couponAmt,
                                  ).toFixed(2)}
                                </b>
                              ) : (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {Math.max(
                                    0,
                                    amountToPay.initialAmt -
                                    initialPaymentDtl.couponAmt,
                                  ).toFixed(2)}
                                </b>
                              )}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="registrationPaymentCard mt-4">
                  <div className="registrationMidd">
                    <div className="registrationMiddLeft">
                      <ul>
                        {initialPaymentDtl.isCouponApplied === false && (
                          <li>
                            <div class="listCardBox">
                              <div className="listCard">
                                <span className="coupanColor">
                                  Add Coupon Code
                                </span>
                                <div className="applyInput d-flex gap-2 align-items-center">
                                  <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Enter code"
                                    ref={couponRef}
                                  />{" "}
                                  <a
                                    className="btn-link-active"
                                    onClick={() => applyCouponRes()}
                                  >
                                    Apply
                                  </a>
                                </div>
                              </div>
                              <div className="listCard">
                                <a
                                  className="btn-link-active"
                                  onClick={() => setavailableCoupan(true)}
                                >
                                  View coupons
                                </a>
                              </div>
                            </div>
                          </li>
                        )}
                        {initialPaymentDtl.isCouponApplied === true && (
                          <li>
                            <span
                              className="successText"
                              style={{ color: "#4CAF50", fontWeight: 500 }}
                            >
                              <img src={successful} alt="#" style={{ marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: "10px" }} />
                              By using {initialPaymentDtl.couponCode}, you saved{" "}
                              <b>
                                {amountToPay.currencyType}{" "}
                                {initialPaymentDtl.couponAmt}
                              </b>
                            </span>
                            <b
                              className="subTitleTiel cursor-pointer"
                              onClick={() => removeCouponCodeRes()}
                            >
                              Remove
                            </b>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {activeTabs.paymentDetail === true &&
              isInitialPayment === false && (
                <div className="registrationPaymentMain">
                  <div className="registrationPaymentCard">
                    <div className="registrationPaymentHead">
                      <h3>
                        {articleDetail?.updateFlow === true
                          ? "New Article Update Payment"
                          : "Final Article processing charge"}
                      </h3>
                      {articleDetail?.updateFlow === true && (
                        <div className="questionBox reddot updatePaymentmsg">
                          {" "}
                          <span>
                            Please apply the coupon code you have received in
                            email below
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="registrationMidd">
                      <div className="registrationMiddLeft">
                        <h4>Bill Summary</h4>
                        <ul>
                          {isMegaJournal ? (
                            <>
                              <li>
                                <div className="listCardBox">
                                  <div className="listCard">
                                    <span>Article Processing Charge</span>
                                    <div className="">
                                      <b>
                                        {amountToPay.currencyType} 3999
                                      </b>
                                    </div>
                                  </div>

                                  {finalPaymentDtl.isCouponApplied === true && (
                                    <div className="listCard">
                                      <span>Coupon Applied</span>
                                      <div className="">
                                        <b>
                                          - {amountToPay.currencyType}{" "}
                                          {finalPaymentDtl.couponAmt}
                                        </b>{" "}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </li>

                              <li>
                                <div className="grandCardBox">
                                  <div className="grandCardList">
                                    <span className="subTitle">Net Payable</span>
                                    <b className="mudraText">
                                      {amountToPay.currencyType}{" "}
                                      {finalPaymentDtl.finalAmt}
                                    </b>
                                  </div>
                                </div>
                              </li>
                            </>
                          ) : (
                            <>
                              {articleDetail?.updateFlow !== true && (
                                <li>
                                  <div className="listCardBox">
                                    {amountToPay.finalStrike === true && (
                                      <div className="listCard">
                                        <span>Article Processing Charge</span>
                                        <div className="">
                                          <b>
                                            <del>
                                              {amountToPay.currencyType}{" "}
                                              {amountToPay.listpriceFinal}
                                            </del>
                                          </b>
                                        </div>
                                      </div>
                                    )}
                                    <div className="listCard">
                                      <span>Introductory Price</span>
                                      <div className="">
                                        <b>
                                          {amountToPay.currencyType}{" "}
                                          {amountToPay.finalAmt}
                                        </b>
                                      </div>
                                    </div>

                                    {finalPaymentDtl.isCouponApplied === true && (
                                      <div className="listCard">
                                        <span>Coupon Applied</span>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType}{" "}
                                            {finalPaymentDtl.couponAmt}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}

                                    {finalPaymentDtl.isGrantApplied === true && (
                                      <div className="listCard">
                                        <b>Grant Applied</b>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType}{" "}
                                            {finalPaymentDtl.grantAmount}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}
                                    {finalPaymentDtl.isMudraApplied === true && (
                                      <div className="listCard">
                                        <span>Mudras Applied</span>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType} {mudras}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              )}
                              {articleDetail?.updateFlow === true && (
                                <li>
                                  <div className="listCardBox">
                                    <div className="listCard">
                                      <span>Introductory Price</span>
                                      <div className="">
                                        <b>
                                          {amountToPay.currencyType}{" "}
                                          {amountToPay.finalAmt}
                                        </b>{" "}
                                      </div>
                                    </div>
                                    {finalPaymentDtl.isCouponApplied === true && (
                                      <div className="listCard">
                                        <span>Coupon Applied</span>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType}{" "}
                                            {finalPaymentDtl.couponAmt}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}

                                    {finalPaymentDtl.isGrantApplied === true && (
                                      <div className="listCard">
                                        <b>Grant Applied</b>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType}{" "}
                                            {finalPaymentDtl.grantAmount}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}
                                    {finalPaymentDtl.isMudraApplied === true && (
                                      <div className="listCard">
                                        <span>Mudras Applied</span>
                                        <div className="">
                                          <b>
                                            - {amountToPay.currencyType} {mudras}
                                          </b>{" "}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              )}

                              <li>
                                <div className="grandCardBox">
                                  <div className="grandCardList">
                                    <span className="subTitle">Net Payable</span>
                                    <b className="mudraText">
                                      {amountToPay.currencyType}{" "}
                                      {handleGstPayment(
                                        finalPaymentDtl.finalAmt.toFixed(2),
                                      )}
                                    </b>
                                  </div>
                                </div>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                      <div className="registrationMiddRight">
                        <ul>
                          {user?.nationality === "withInIndia" &&
                            finalPaymentDtl.isMudraApplied === false &&
                            mudras > 0 && (
                              <li>
                                <span className="subTitleTiel">
                                  Available Mudras{" "}
                                  <div className="customTool">
                                    {["bottom"].map((placement) => (
                                      <OverlayTrigger
                                        key={placement}
                                        placement={placement}
                                        overlay={
                                          <Popover>
                                            <Popover.Body>
                                              <div className="popoverToolWrap">
                                                <p>
                                                  The available mudras can be
                                                  reviewed in your Mudra Kosh
                                                  (Wallet) account and used to
                                                  make the payment.
                                                </p>
                                                <br />
                                                <p>
                                                  You can use these to make
                                                  payment for a new article or
                                                  update an existing article.
                                                </p>
                                                <p>
                                                  Access your Mudra Kosh Account
                                                  here.
                                                </p>
                                              </div>
                                            </Popover.Body>
                                          </Popover>
                                        }
                                      >
                                        <img
                                          className="pe-cursor ps-1"
                                          src={active_info}
                                          alt="no img"
                                        />
                                      </OverlayTrigger>
                                    ))}
                                  </div>
                                </span>
                                <div className="subtotalPrice">
                                  <b className="mudra">{mudras}</b>{" "}
                                  <span
                                    className="btn-link-active"
                                    onClick={() => applyMudra()}
                                  >
                                    Apply
                                  </span>
                                </div>
                              </li>
                            )}
                          {finalPaymentDtl.isMudraApplied === true && (
                            <li>
                              <span className="successText">
                                <img src={successful} alt="#" style={{ marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: "10px" }} />
                                By using Mudras, you saved{" "}
                                <b>
                                  {amountToPay.currencyType} {mudras}
                                </b>
                              </span>
                              <b
                                className="subTitleTiel cursor-pointer"
                                onClick={() => removeMudra()}
                              >
                                Remove
                              </b>
                            </li>
                          )}
                          {finalPaymentDtl.isCouponApplied === false && (
                            <li>
                              <div class="listCardBox">
                                <div className="listCard">
                                  <span className="coupanColor">
                                    Add Coupon Code
                                  </span>
                                  <div className="applyInput">
                                    <input
                                      type="text"
                                      placeholder="Enter code"
                                      ref={couponRef}
                                    />{" "}
                                    <a
                                      className="btn-link-active"
                                      onClick={() => applyCoupon()}
                                    >
                                      Apply
                                    </a>
                                  </div>
                                </div>
                                <div className="listCard">
                                  <a
                                    className="btn-link-active"
                                    onClick={() => setavailableCoupan(true)}
                                  >
                                    View coupons
                                  </a>
                                </div>
                              </div>
                            </li>
                          )}
                          {finalPaymentDtl.isCouponApplied === true && (
                            <li>
                              <span className="successText">
                                <img src={successful} alt="#" style={{ marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: "10px" }} />
                                By using {finalPaymentDtl.couponCode}, you saved{" "}
                                <b>
                                  {amountToPay.currencyType}{" "}
                                  {finalPaymentDtl.couponAmt}
                                </b>
                              </span>
                              <b
                                className="subTitleTiel cursor-pointer"
                                onClick={() => removeCouponCode()}
                              >
                                Remove
                              </b>
                            </li>
                          )}
                        </ul>
                        {articleDetail?.updateFlow === true ? null : (
                          <></>
                          // <div className="questionBox reddot">
                          //   <span>
                          //     Don’t forgot to apply coupon its 100% discount.
                          //   </span>
                          // </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="paymentCheck d-block">
                    <label className="customCheck w-100">
                      <Checkbox
                        id="isTermAccept"
                        name="isTermAccept"
                        onRadioChange={acceptToc}
                        className="form-check-input"
                        checked={finalPaymentDtl.isTermAccept}
                      />

                      <i></i>
                      <b>
                        I and/or my fellow co-authors have read, understood and
                        hereby accept the{" "}
                        <a
                          className="btn-link-active inputSet"
                          href="/terms-conditions"
                          target="_blank"
                        >
                          Aakashganga Terms & Conditions
                        </a>{" "}
                        <span className="mandatoryText">(Mandatory)</span>
                      </b>
                    </label>
                  </div>
                </div>
              )}

            {activeTabs.success === true && isInitialPayment === false && (
              <div className="registrationPaymentMain">
                <div className="registrationPaymentCard">
                  <div className="registrationPaymentHead" style={{ backgroundColor: "#e8f5e9", borderBottom: "1px solid #c8e6c9", padding: "20px 24px", textAlign: "center", borderRadius: "12px 12px 0 0" }}>
                    <div className="articleSuccess" style={{ justifyContent: "center" }}>
                      <span style={{ color: "#2e7d32", fontSize: "22px", fontWeight: "bold" }}>
                        <img src={successful} alt="#" style={{ width: "32px", marginRight: "10px" }} />{" "}
                        🎉 Congratulations! Payment Successful
                      </span>
                    </div>
                    <p style={{ margin: "10px 0 0 0", color: "#2e7d32", fontSize: "15px", fontWeight: "500" }}>
                      Your Article Processing Charge (APC) payment has been successfully completed. The admin team has been notified and will proceed with the editorial workflow.
                    </p>
                  </div>

                  <div className="registrationMidd">
                    <div className="registrationMiddLeft">
                      <h4>Payment Details</h4>
                      <ul>
                        <li>
                          <div className="listCardBox">
                            {articleDetail?.updateFlow !== true &&
                              amountToPay.finalStrike === true && (
                                <div className="listCard">
                                  <span>Article Processing Charge</span>
                                  <div className="">
                                    <b>
                                      <del>
                                        {amountToPay.currencyType}{" "}
                                        {amountToPay.listpriceFinal.toFixed(2)}
                                      </del>
                                    </b>
                                  </div>
                                </div>
                              )}
                            <div className="listCard">
                              <span>Introductory Price</span>
                              <div className="">
                                <b>
                                  {amountToPay.currencyType}{" "}
                                  {amountToPay.finalAmt}
                                </b>
                              </div>
                            </div>
                            {finalPaymentDtl.isCouponApplied === true && (
                              <div className="listCard">
                                <span>Coupon Applied</span>
                                <div className="">
                                  <b>
                                    - {amountToPay.currencyType}{" "}
                                    {finalPaymentDtl.couponAmt}
                                  </b>
                                </div>
                              </div>
                            )}
                            {finalPaymentDtl.isGrantApplied === true && (
                              <div className="listCard">
                                <span>Grant Applied</span>
                                <div className="">
                                  <b>
                                    - {amountToPay.currencyType}{" "}
                                    {finalPaymentDtl.grantAmount}
                                  </b>
                                </div>
                              </div>
                            )}
                            {finalPaymentDtl.isMudraApplied === true && (
                              <div className="listCard">
                                <span>Mudras Applied</span>
                                <div className="">
                                  <b>
                                    - {amountToPay.currencyType} {mudras}
                                  </b>
                                </div>
                              </div>
                            )}
                          </div>
                        </li>

                        <li className="grandTotalList">
                          <div className="grandCardBox">
                            <div className="grandCardList">
                              <span className="subTitle">Net Payable</span>
                              <b className="mudra sm-mudra">
                                {amountToPay.currencyType}{" "}
                                {handleGstPayment(
                                  finalPaymentDtl.finalAmt.toFixed(2),
                                )}
                              </b>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>Payment Mode</span>
                              <div className="">
                                <b>{paymentFailedPopup.card_type}</b>
                              </div>
                            </div>
                            <div className="listCard">
                              <span>Transaction ID</span>
                              <div className="">
                                <b>{paymentFailedPopup.txnId}</b>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>
                                <h4>Receipt</h4>
                              </span>
                              <a
                                onClick={() => downLoadReciepts("download")}
                                download
                                className="cursor-pointer"
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="paymentCheck mailBoxPay">
                  <label className="customCheck">
                    <Checkbox
                      onRadioChange={getReceipt}
                      className="form-check-input"
                      checked={activeTabs.getReceipt}
                      name="isReviwer"
                    />
                    <i></i>
                    <b>Please send a copy of this receipt to my mailbox</b>
                  </label>
                  {articleDetail?.updateFlow !== true && (
                    <div
                      className="button button-primary"
                      onClick={() => navigate(`/viewPublishedArticle/${articleDetail?.slug || articleDetail?._id}`)}
                      style={{ cursor: "pointer" }}
                    >
                      Continue
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTabs.success === true && isInitialPayment === true && (
              <div className="registrationPaymentMain">
                <div className="registrationPaymentCard">
                  <div className="registrationPaymentHead">
                    <div className="articleSuccess">
                      <span>
                        <img src={successful} alt="#" /> Payment SUCCESSFUL{" "}
                      </span>
                    </div>
                  </div>
                  <div className="registrationMidd">
                    <div className="registrationMiddLeft w-100">
                      <h4>Payment Details</h4>
                      <ul>
                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>Article Processing Charge</span>
                              <b>
                                {amountToPay.currencyType}{" "}
                                {amountToPay.initialAmt.toFixed(2)}
                              </b>
                            </div>
                          </div>
                        </li>
                        {user?.nationality === "withInIndia" ? (
                          <li>
                            <div className="listCardBox">
                              <div className="listCard">
                                <span>GST - 18%</span>
                                <b>
                                  {amountToPay.currencyType}{" "}
                                  {isSocietyConferencePaper
                                    ? mwpValues.gstVal.toFixed(2)
                                    : (
                                      (18 / 100) *
                                      amountToPay.initialAmt
                                    ).toFixed(2)}
                                </b>
                              </div>
                            </div>
                          </li>
                        ) : null}

                        {initialPaymentDtl.isCouponApplied === true && (
                          <li>
                            <div className="listCardBox">
                              <div className="listCard">
                                <span>Coupon Applied</span>
                                <b>
                                  - {amountToPay.currencyType}{" "}
                                  {initialPaymentDtl.couponAmt}
                                </b>
                              </div>
                            </div>
                          </li>
                        )}

                        <li>
                          <div className="grandCardBox">
                            <div className="grandCardList">
                              <span className="subTitle">Net Payable</span>
                              {isMWP ? (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {mwpValues.netPayable.toFixed(2)}
                                </b>
                              ) : user?.nationality === "withInIndia" ? (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {Math.max(
                                    0,
                                    amountToPay.initialAmt +
                                    (18 / 100) * amountToPay.initialAmt -
                                    initialPaymentDtl.couponAmt,
                                  ).toFixed(2)}
                                </b>
                              ) : (
                                <b className="mudra sm-mudra">
                                  {amountToPay.currencyType}{" "}
                                  {Math.max(
                                    0,
                                    amountToPay.initialAmt -
                                    initialPaymentDtl.couponAmt,
                                  ).toFixed(2)}
                                </b>
                              )}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>Payment Mode</span>
                              <b>{paymentFailedPopup.card_type}</b>
                            </div>

                            <div className="listCard">
                              <span>Transaction ID</span>
                              <b>{paymentFailedPopup.txnId}</b>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="listCardBox">
                            <div className="listCard">
                              <span>
                                <h4>Receipt</h4>
                              </span>
                              <a
                                onClick={() => downLoadReciepts("download")}
                                download
                                className="cursor-pointer"
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="paymentCheck">
                  <div className="">
                    <label className="customCheck">
                      <Checkbox
                        name="isReviwer"
                        onRadioChange={getReceipt}
                        className="form-check-input"
                        checked={activeTabs.getReceipt}
                      />
                      <i></i>
                      <b>Please send a copy of this receipt to my mailbox</b>
                    </label>

                    {articleDetail?.paymentBySociety?.apcPayBySociety ===
                      true && !isMWP && (
                        <label className="customCheck">
                          <Checkbox
                            onRadioChange={handleFullCharge}
                            name="isReviwer"
                            checked={activeTabs.aggryToc}
                            className="form-check-input"
                          />
                          <i></i>
                          <b>
                            I and/or my fellow co-authors are fully aware of and
                            agree to pay the balance of Article Processing Charge
                            (APC), should<br />
                            the manuscript be accepted for publishing{" "}

                            <span className="mandatoryText">(Mandatory)</span>
                          </b>
                        </label>
                      )}
                  </div>
                </div>
              </div>
            )}
            {finalPaymentStatus === false && (
              <div
                className="confirmFooter"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "calc(100% - 88px)",
                  maxWidth: "1096px",
                  zIndex: "999",
                  backgroundColor: "#006F94",
                  boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "15px 30px",
                  }}
                >
                  <div
                    className="left-content-wrapper"
                    style={{ marginRight: "80px" }}
                  >
                    {isInitialPayment === true &&
                      activeTabs.success === false && (
                        <div className="confirmContent">
                          <h3
                            style={{
                              color: "#FFFFFF",
                              textTransform: "uppercase",
                            }}
                          >
                            {((articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "minorities in world politics" ||
                               articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "community learning and social transformation" ||
                               articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "applied and basic obesity, diabetes and endocrinology" ||
                               articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                               articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf")) ? (
                              <>
                                Final APC Payment:{" "}
                                <b style={{ color: "#FFB01B" }}>
                                  {amountToPay.currencyType} {mwpValues.netPayable.toFixed(2)}
                                </b>
                              </>
                            ) : (
                              <>
                                Article Registration Payment:{" "}
                                <b style={{ color: "#FFB01B" }}>
                                  {amountToPay.currencyType}{" "}
                                  {amountToPay.initialAmt}
                                </b>
                              </>
                            )}
                          </h3>

                          {articleDetail?.submissionDetail?.articleType?._id !=
                            "664aed76ada7b4f743b760a9" ? (
                            <>
                              <div
                                className="questionBox"
                                style={{ borderLeft: "none", paddingLeft: 0 }}
                              >
                                {((articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "minorities in world politics" ||
                                   articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "community learning and social transformation" ||
                                   articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase() === "applied and basic obesity, diabetes and endocrinology" ||
                                   articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                                   articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf")) ? (
                                  <span
                                    style={{ color: "#FFFFFF", fontSize: "14px", display: "block" }}
                                  >
                                    Your article has successfully completed the editorial and <br />
                                    peer-review process and is now ready for final publication. <br />
                                    Upon successful APC payment confirmation, the article will proceed to publication and DOI assignment.
                                  </span>
                                ) : (
                                  <>
                                    <span
                                      style={{ color: "#FFFFFF", fontSize: "14px", display: "block" }}
                                    >
                                      The remaining balance of{" "}
                                      {amountToPay.currencyType}{" "}
                                      {amountToPay.finalAmt -
                                        amountToPay.initialAmt}{" "}
                                      will be charged
                                    </span>
                                    <span
                                      style={{ color: "#FFFFFF", fontSize: "14px", display: "block" }}
                                    >
                                      after your article is accepted for publishing
                                    </span>
                                  </>
                                )}
                              </div>
                            </>
                          ) : null}
                        </div>
                      )}
                    {isInitialPayment === true &&
                      activeTabs.success === true && (
                        <div className="confirmContent">
                          {isMWP ? (
                            <h3
                              style={{
                                color: "#FFFFFF",
                                textTransform: "uppercase",
                              }}
                            >
                              ARTICLE PROCESSING CHARGE PAID:{" "}
                              <b style={{ color: "#FFB01B" }}>
                                {amountToPay.currencyType} {mwpValues.netPayable.toFixed(2)}
                              </b>
                            </h3>
                          ) : (
                            <>
                              <h3
                                style={{
                                  color: "#FFFFFF",
                                  textTransform: "uppercase",
                                }}
                              >
                                ARTICLE PROCESSING CHARGE:{" "}
                                <b style={{ color: "#FFB01B" }}>
                                  {amountToPay.currencyType}{" "}
                                  {finalPaymentDtl.finalAmt}
                                </b>
                              </h3>

                              <div
                                className="questionBox"
                                style={{ borderLeft: "none", paddingLeft: 0 }}
                              >
                                <span
                                  style={{
                                    color: "#FFFFFF",
                                    fontSize: "14px",
                                    display: "block",
                                  }}
                                >
                                  You may also be eligible for additional grants and
                                  discounts
                                </span>
                                <span
                                  style={{
                                    color: "#FFFFFF",
                                    fontSize: "14px",
                                    display: "block",
                                  }}
                                >
                                   {isMegaJournal
                                     ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                                     : "All offers will be applied after the article is accepted for publication"}
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    {!isMWP &&
                      articleDetail?.status === "approved" &&
                      articleDetail?.finalPayment === false &&
                      activeTabs.success === false && (
                        <div className="confirmContent">
                          {isMegaJournal ? (
                            <h3 style={{ color: "#FFFFFF" }}>
                              ARTICLE PROCESSING CHARGE PAYABLE:{" "}
                              <b style={{ color: "#FFB01B" }}>
                                {amountToPay.currencyType}{" "}
                                {finalPaymentDtl.finalAmt}
                              </b>
                            </h3>
                          ) : user?.nationality === "withInIndia" ? (
                            <h3 style={{ color: "#FFFFFF" }}>
                              ARTICLE PROCESSING CHARGE payable:{" "}
                              <b style={{ color: "#FFB01B" }}>
                                {amountToPay.currencyType}{" "}
                                {handleGstPayment(
                                  (
                                    finalPaymentDtl.finalAmt +
                                    (18 / 100) * finalPaymentDtl.finalAmt
                                  ).toFixed(2),
                                )}
                              </b>
                            </h3>
                          ) : (
                            <h3 style={{ color: "#FFFFFF" }}>
                              ARTICLE PROCESSING CHARGE payable:{" "}
                              <b style={{ color: "#FFB01B" }}>
                                {amountToPay.currencyType}{" "}
                                {finalPaymentDtl.finalAmt.toFixed(2)}
                              </b>
                            </h3>
                          )}
                        </div>
                      )}
                    {articleDetail?.updateFlow === true && (
                      <div className="confirmContent">
                        <h3>&nbsp;</h3>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    {isInitialPayment === true &&
                      activeTabs.success === false && (
                        <span
                          className="btn-link-gray bold"
                          style={{
                            backgroundColor: "#FFFFFF",
                            width: "160px",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            const mwpJName6 = articleDetail?.submissionDetail?.journalName?.trim()?.toLowerCase();
                            const isMWP =
                              (mwpJName6 === "minorities in world politics" ||
                               mwpJName6 === "community learning and social transformation" ||
                               mwpJName6 === "applied and basic obesity, diabetes and endocrinology" ||
                               articleDetail?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
                               articleDetail?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf");
                            if (isMWP) {
                              e.preventDefault();
                              window.close();
                              setTimeout(() => {
                                navigate(-1);
                              }, 100);
                            } else {
                              handleRedirect(
                                e,
                                `/dashboard/edit-article/${articleDetail._id}`,
                              );
                            }
                          }}
                        >
                          Cancel
                        </span>
                      )}
                    {user.nationality !== "outSideIndia" &&
                      isInitialPayment === true &&
                      activeTabs.success === false && (
                        <button
                          disabled={activeTabs.success || !articleDetail?._id}
                          className="button button-primary"
                          type="button"
                          onClick={paymentInitiation}
                          style={{
                            backgroundColor: "#FFFFFF",
                            width: "250px",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {(isMWP && mwpValues.netPayable === 0)
                            ? "Continue to Publish"
                            : "Continue to Payment"}
                        </button>
                      )}
                    {user.nationality === "outSideIndia" &&
                      isInitialPayment === true &&
                      activeTabs.success === false && (
                        (isMWP && mwpValues.netPayable === 0) ? (
                          <button
                            disabled={activeTabs.success || !articleDetail?._id}
                            className="button button-primary"
                            type="button"
                            onClick={paymentInitiation}
                            style={{
                              backgroundColor: "#FFFFFF",
                              width: "250px",
                              height: "44px",
                              color: "#006F94",
                              border: "none",
                              fontWeight: "bold",
                              borderRadius: "10px",
                              padding: "0 25px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Continue to publish
                          </button>
                        ) : (
                          <PayPalScriptProvider options={initialOptionsPaypal}>
                            <PayPalButtons
                              createOrder={(data, actions) =>
                                createOrder(data, actions)
                              }
                              onApprove={onApprove}
                              fundingSource={FUNDING.PAYPAL}
                              style={{
                                layout: "vertical",
                                color: "blue",
                                label: "pay",
                              }}
                              onCancel={onCancelPayapl}
                              onError={onErrorPayapl}
                            />
                          </PayPalScriptProvider>
                        )
                      )}                     {!isMWP &&
                        user.nationality === "outSideIndia" &&
                        (articleDetail?.status === "approved" ||
                          articleDetail?.updateFlow === true) &&
                        articleDetail?.finalPayment === false &&
                        activeTabs.success === false &&
                        finalPaymentDtl.finalAmt > 0 ? (
                        <PayPalScriptProvider options={initialOptionsPaypal}>
                          <PayPalButtons
                            style={{
                              layout: "vertical",
                              color: "blue",
                              label: "pay",
                            }}
                            createOrder={(data, actions) =>
                              createOrder(data, actions)
                            }
                            onApprove={onApprove}
                            fundingSource={FUNDING.PAYPAL}
                            disabled={!finalPaymentDtl.isTermAccept}
                          />
                        </PayPalScriptProvider>
                      ) : !isMWP &&
                        user.nationality === "outSideIndia" &&
                        (articleDetail?.status === "approved" ||
                          articleDetail?.updateFlow === true) &&
                        articleDetail?.finalPayment === false &&
                        activeTabs.success === false &&
                        finalPaymentDtl.finalAmt <= 0 ? (
                        <button
                          className="button button-primary"
                          type="button"
                          onClick={paymentInitiation}
                          style={{
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          Continue to Payment
                        </button>
                      ) : null}
                    {!isMWP &&
                      user.nationality !== "outSideIndia" &&
                      (articleDetail?.status === "approved" ||
                        articleDetail?.updateFlow === true) &&
                      articleDetail?.finalPayment === false &&
                      activeTabs.success === false && (
                        <button
                          className="button button-primary"
                          type="button"
                          onClick={paymentInitiation}
                          style={{
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          Continue to Payment
                        </button>
                      )}
                    {(isMWP || articleDetail?.initialPayment === false) &&
                      activeTabs.success === true &&
                      isInitialPayment === true && (
                        <button
                          disabled={
                            !isMWP &&
                            articleDetail?.paymentBySociety?.apcPayBySociety ===
                            true && !activeTabs.aggryToc
                          }
                          className="button button-primary"
                          type="button"
                          onClick={continueWithArticle}
                          style={{
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Continue{" "}
                        </button>
                      )}
                    {articleDetail?.updateFlow === true &&
                      activeTabs.success === true && (
                        <button
                          className="button button-primary"
                          type="button"
                          onClick={(e) =>
                            handleRedirect(
                              e,
                              `/dashboard/edit-article/${articleDetail._id}`,
                            )
                          }
                          style={{
                            backgroundColor: "#FFFFFF",
                            height: "44px",
                            color: "#006F94",
                            border: "none",
                            fontWeight: "bold",
                            borderRadius: "10px",
                            padding: "0 25px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          Continue{" "}
                        </button>
                      )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <Modal
        size="md"
        show={paymentFailedPopup.status}
        id="congratsMobile"
        tabIndex={-1}
        className=" authorModal authorModalRed"
        centered
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertSvg} alt="#" />
          </div>
          <h5 className="modal-title mb-0">payment failed</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setpaymentFailedPopup({ status: false, txnId: "" })}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="congratulationsPopup">
            <p className="text-center">
              Your transaction has failed. Please try again
            </p>
            {paymentFailedPopup.txnId !== "" && (
              <div className="transactionWrap">
                <b>Transaction ID:</b>
                <span>{paymentFailedPopup.txnId}</span>
              </div>
            )}
            <div className="text-center">
              <button
                className="button button-primary redBtn"
                onClick={() =>
                  setpaymentFailedPopup({ status: false, txnId: "" })
                }
              >
                try again
              </button>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-3">
          <div className="helpPopupText mt-4">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=" modal-sm modal-dialog  "
        size="md"
        show={paymentSuccess}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Receipt Sent Successfully </h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setsavedDetailsPupup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave text-center">
            <p>Please check your registered email address</p>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <span
            className="button button-primary sm ml-3"
            onClick={(e) =>
              handleRedirect(e, `/dashboard/edit-article/${articleDetail._id}`)
            }
          >
            continue submitting my article
          </span>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName=" modal-sm modal-dialog  "
        size="md"
        show={availableCoupan}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">
            <img src={coupanIcon} alt="#" className="availCoup" />{" "}
            {offers.length < 1 ? (
              <span className="text-transform-none">
                No coupons available currently
              </span>
            ) : (
              "Available Coupons"
            )}
          </h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setavailableCoupan(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="availableCoupanModal">
            <ul>
              {offers.map((offer) => (
                <li>
                  <div className="coupanCard">
                    <div className="coupanHead">
                      <div className="coupanCopy">
                        <b>Coupon Code</b>
                        <strong onClick={() => copyCouponCode(offer.offerCode)}>
                          {offer.offerCode} <img src={copyIcon} alt="#" />
                        </strong>
                      </div>
                      <span className="offOfer">
                        {offer.offerType === "Percentage off"
                          ? `${offer.value}% Off`
                          : `${offer?.currency} ${offer.value} Off`}
                      </span>
                    </div>
                    <div className="coupanFoot">
                      <span>
                        <b>Expiration:</b> {convertDateFormate(offer.endDate)}
                      </span>
                      <a href="/terms-conditions" target="_blank">
                        View T&C
                      </a>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogclassName=" modal-sm modal-dialog  "
        size="md"
        show={articlePublishedModal}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Confetti width={"450px"} height={"480px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">congratulations </h5>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave text-left pl-4">
            <h3 className="researchTextGreen">
              Your Research Article Is On <br />
              Its Way to Final Publication 🎉
            </h3>
            <p className="">
              Now that you've successfully completed the payment, it's time for
              you to sit back, relax,
              <br />
              and take a well-deserved breather.
            </p>

            <p className=" mt-3">
              The article will now follow our automated workflow and should soon
              be visible to the world. We will let you know as soon as this
              happens.
            </p>
            <p className=" mt-3">
              We'll keep you informed every step of the <br />
              way, so you'll know exactly when your article <br />
              is set to make its debut on our platform.
            </p>
            <p className=" mt-3">
              In the meantime, if you have any questions
              <br />
              or simply want to share your excitement, <br />
              feel free to reach out to us anytime. We <br />
              love celebrating achievements together!
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="pb-3">
          <span
            className="button button-primary sm ml-3"
            onClick={handleOkayClick}
            style={{ cursor: "pointer" }}
          >
            OKAY
          </span>

          <div className="helpPopupText mt-4">
            Need help? Write to us at
            <a href="mailto:contactus@vikramshilaedu.in">
              contactus@vikramshilaedu.in
            </a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName="modal-sm modal-dialog"
        size="md"
        show={mwpPublishedModal}
        id="congratsMwp"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Confetti width={"450px"} height={"480px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Congratulations</h5>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave text-left pl-4">
            <h3 className="researchTextGreen">
              Your Research Article Is Published 🎉
            </h3>
            <p className="">
              Your article has been successfully published on the platform and is now visible to the world.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="pb-3" style={{ display: 'flex', gap: '10px', justifyContent: 'center', borderTop: 'none' }}>
          <button
            className="button button-outline sm"
            style={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #006F94',
              color: '#006F94',
              fontWeight: 'bold',
              borderRadius: '10px',
              height: '44px',
              padding: '0 25px',
              cursor: 'pointer'
            }}
            onClick={() => {
              setMwpPublishedModal(false);
              window.open(`/viewPublishedArticle/${articleDetail?.slug || articleDetail?._id}`, '_blank');
            }}
          >
            View Article
          </button>
          <button
            className="button button-primary sm"
            style={{
              backgroundColor: '#006F94',
              border: 'none',
              color: '#FFFFFF',
              fontWeight: 'bold',
              borderRadius: '10px',
              height: '44px',
              padding: '0 25px',
              cursor: 'pointer'
            }}
            onClick={() => {
              setMwpPublishedModal(false);
              localStorage.setItem("getPEType", "published");
              navigate('/dashboard/society-editor');
            }}
          >
            Dashboard
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default articleRegistrationPayment;
